import type { NativeShellService } from "../types"

export const nativeShell: NativeShellService = {
  async applyStatusBar() {},
  requestStatusBarRestore() {},
  subscribeStatusBarRestore() {
    return () => {}
  },
}
